import React from 'react';

const Money = props => {
  /* eslint-disable */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
      <g
        fill="none"
        fillRule="evenodd"
        stroke={props.color || '#CCC'}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M1.467 14.533h21.466V1.467H1.467z" />
        <path d="M15.233 8.117a2.916 2.916 0 1 1-5.833 0 2.916 2.916 0 0 1 5.833 0z" />
        <path
          fill={props.color || '#CCC'}
          d="M6.367 5.2a1.167 1.167 0 1 1-2.335 0 1.167 1.167 0 0 1 2.335 0zM20.6 11.033a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.334 0z"
        />
      </g>
    </svg>
  );
  /* eslint-enable */
};

export default Money;



// WEBPACK FOOTER //
// ./src/components/Icons/Money.js